let URL;
switch (process.env.NODE_ENV) {
  case "production":
    URL = "https://wms.tapdoandaiviet.com.vn/";
    break;
  case "uat":
    URL = "https://wms-uat.baspro.vn/";
    break;
  case "staging":
    URL = "https://wms-staging.baspro.vn/";
    break;
  case "test":
    URL = "https://wms-test.baspro.vn/";
    break;
  default:
    URL = "http://localhost:8080/";
    break;
}
export default URL;
